/**
 * 投诉相关api
 *
 * @param http
 * @returns {{pushError2DingTalk(*): *, modifyPassword(*): *, queryAll(*): *}|*}
 */
export default (http) => {
    return {
        queryByPage (data){
            return http.json({
                url: '/complaint/query',
                data
            })
        },
        list (data){
            return http.json({
                url: '/complaint/backList',
                data
            })
        },
        /**
         * 保存信息
         * @param data
         * @returns {*}
         */
        saveInfo(data) {
            return http.json({
                url: '/complaint/save',
                data
            })
        },
        /**
         * 获取详情
         * @param data
         * @return {*}
         */
        getInfo(data) {
            return http.json({
                url: `/complaint/get?id=${data.id.id}`
            })
        },
        /**
         * 删除
         * @param data
         * @returns {*}
         */
        removeInfo(data) {
            return http.json({
                url: `/complaint/delete?id=${data[0].id}`,
                data
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/complaint.js